import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PaginationButton } from './PaginationButton-B4M4YmwW.js';
import { v as angleDoubleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const PaginationLastButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-last-button'),
  icon: angleDoubleInlineEnd
}, props));
PaginationLastButton.displayName = 'PaginationLastButton';

export { PaginationLastButton as P };
//# sourceMappingURL=PaginationLastButton-Bgw4Ko0W.js.map
